import { render, staticRenderFns } from "./CognitiveCGJD.vue?vue&type=template&id=16692380&scoped=true"
import script from "./CognitiveCGJD.vue?vue&type=script&lang=js"
export * from "./CognitiveCGJD.vue?vue&type=script&lang=js"
import style0 from "./CognitiveCGJD.vue?vue&type=style&index=0&id=16692380&prod&scoped=true&lang=css"
import style1 from "./CognitiveCGJD.vue?vue&type=style&index=1&id=16692380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16692380",
  null
  
)

export default component.exports